(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-feature-entity-map', {
            parent: 'entity',
            url: '/application-feature-entity-map',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureEntityMap.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map.html',
                    controller: 'ApplicationFeatureEntityMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureEntityMap');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-feature-entity-map-detail', {
            parent: 'entity',
            url: '/application-feature-entity-map/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureEntityMap.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-detail.html',
                    controller: 'ApplicationFeatureEntityMapDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureEntityMap');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationFeatureEntityMap', function($stateParams, ApplicationFeatureEntityMap) {
                    return ApplicationFeatureEntityMap.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('application-feature-entity-map.new', {
            parent: 'application-feature-entity-map',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-dialog.html',
                    controller: 'ApplicationFeatureEntityMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-feature-entity-map', null, { reload: true });
                }, function() {
                    $state.go('application-feature-entity-map');
                });
            }]
        })
        .state('application-feature-entity-map.edit', {
            parent: 'application-feature-entity-map',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-dialog.html',
                    controller: 'ApplicationFeatureEntityMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationFeatureEntityMap', function(ApplicationFeatureEntityMap) {
                            return ApplicationFeatureEntityMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-entity-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-feature-entity-map.delete', {
            parent: 'application-feature-entity-map',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-delete-dialog.html',
                    controller: 'ApplicationFeatureEntityMapDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationFeatureEntityMap', function(ApplicationFeatureEntityMap) {
                            return ApplicationFeatureEntityMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-entity-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
